import { render, staticRenderFns } from "./countPtenAction.vue?vue&type=template&id=b9a21b14&scoped=true"
import script from "./countPtenAction.vue?vue&type=script&lang=js"
export * from "./countPtenAction.vue?vue&type=script&lang=js"
import style0 from "./countPtenAction.vue?vue&type=style&index=0&id=b9a21b14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a21b14",
  null
  
)

export default component.exports